import React, {Component} from "react";
import PropTypes from "prop-types";
import Icon from "../common/Icon";
import Select from "../common/Select";
import Radio from "../common/Radio";
import Checkbox from "../common/CheckBox";
import DatePicker from "../common/Date";

import {
    numberMask,
    documentNumberMask,
    unitCodeMask,
    onlyCyrillicChars,
    phoneMask,
    onlyCyrillicCharsNumbersDash
} from "../../tools/mask";
import {
    getObjectData,
    emptyValidator,
    usernameValidator,
    docNumberValidator,
    unitCodeValidator,
    phoneValidator
} from "../../tools/form-helper";
import Tooltip from "../common/Tooltip";
import {normalizeForSelect, setUtmCookie, checkUtmParams, getCookie, isEmptyObj } from "../../tools/tools";
import InputIcon from "../common/InputIcon";
import InputError from "../common/InputError";

export default class FinalMnpForm extends Component{
    constructor(props, context){
        super(props, context);
        let documents = [];
        let defaultDoc = '';

        if (props.personal_info_documents && props.personal_info_documents.length > 0) {

            documents = props.personal_info_documents.map((item) => {
                return {
                    label: item.title,
                    value: item.title
                }
            });

            let defaultDocs = props.personal_info_documents.filter(x => x.default === 1);

            defaultDoc = defaultDocs.length > 0 ? defaultDocs[0].title : '';
        }

        let cities = props.cities && props.cities.filter((item) => {
            return item.region_id == props.regionId;
        });

        let region = props.regions && props.regions.find((item) => {
            return item.id == props.regionId;
        });

        let hasDelivery = cities.length > 0;

        var maxBirthday = new Date();
        maxBirthday.setYear(maxBirthday.getFullYear() - 14);

        let esia = props.forms && props.forms.esiaData;
        
        this.state = {
            fields: {
                fio: {
                    type: "text",
                    label: "ФИО",
                    value: !isEmptyObj(esia) ? `${esia.lastName || ''} ${esia.firstName || ''} ${esia.middleName || ''}` : '',
                    required: true,                     // звездочка
                    mask: onlyCyrillicChars,
                    validators: [usernameValidator],
                    hasError: !isEmptyObj(esia) ? false : null,
                    textError: "Укажите ФИО",
                    readOnly: !isEmptyObj(esia)
                },
                birth_date: {
                    type: "date",
                    label: "ДАТА РОЖДЕНИЯ",
                    value: !isEmptyObj(esia) ? esia.birthDate : '',
                    allowYearDropdown: true,
                    validators: [emptyValidator],
                    hasError: !isEmptyObj(esia) ? false : null,
                    textError: "Укажите дату рождения",
                    required: true,
                    readOnly: !isEmptyObj(esia)
                },
                birth_place: {
                    type: "text",
                    label: "МЕСТО РОЖДЕНИЯ",
                    value: !isEmptyObj(esia) ? esia.birthPlace : '',
                    required: true,                     // звездочка
                    mask: onlyCyrillicCharsNumbersDash,
                    validators: [emptyValidator],
                    hasError: !isEmptyObj(esia) ? false : null,
                    textError: "Укажите место рождения",
                    readOnly: !isEmptyObj(esia)
                },
                callback_phone: {
                    label: "Номер для обратной связи",
                    value: '',
                    mask: phoneMask,
                    validators: [phoneValidator],
                    hasError: null,
                    textError: "Укажите корректный номер телефона",
                    emptyValue: true
                },
                phone: {
                    label: "Номер для переноса",
                    value: phoneMask(props.phone),
                    disabled: true
                },
                getting_type: {
                    type: "radio",
                    value: "pickup",
                    required: true,
                    options: hasDelivery ? [
                        {
                            label: props.getting_type_delivery_title,
                            value: "delivery"
                        },
                        {
                            label: props.getting_type_pickup_title,
                            value: "pickup"
                        }
                    ] : [
                        {
                            label: props.getting_type_pickup_title,
                            value: "pickup"
                        }
                    ]
                },
                document_agreement: {
                    type: "checkbox",
                    label: props.document_agreement_label,
                    value: false,
                    hasError: null
                },

                document: {
                    type: "select",
                    label: "Документ",
                    value: defaultDoc,
                    options: documents,
                    required: true,
                    readOnly: !isEmptyObj(esia)
                },
                document_number: {
                    type: "text",
                    label: "Серия и номер",
                    value: !isEmptyObj(esia) ? `${esia.passport.series || ''} ${esia.passport.number || ''}` : '',
                    mask: documentNumberMask,
                    validators: [docNumberValidator],
                    hasError: !isEmptyObj(esia) ? false : null,
                    textError: "Укажите серию и номер паспорта",
                    required: true,
                    readOnly: !isEmptyObj(esia)
                },
                who_issued: {
                    type: "text",
                    label: "Кем выдан",
                    value: !isEmptyObj(esia) ? esia.passport.issuedBy : '',
                    validators: [usernameValidator],
                    hasError: !isEmptyObj(esia) ? false : null,
                    textError: "Необходимо указать, кем выдан документ",
                    required: true,
                    readOnly: !isEmptyObj(esia)
                },
                issue_date: {
                    type: "date",
                    label: "Дата выдачи",
                    value: !isEmptyObj(esia) ? esia.passport.issueDate : '',
                    allowYearDropdown: true,
                    validators: [emptyValidator],
                    hasError: !isEmptyObj(esia) ? false : null,
                    textError: "Укажите дату выдачи",
                    required: false,
                    readOnly: !isEmptyObj(esia)
                },
                unit_code: {
                    type: "text",
                    label: "Код подразделения",
                    value: !isEmptyObj(esia) ? esia.passport.issueId : '',
                    mask: unitCodeMask,
                    hasError: !isEmptyObj(esia) ? false : null,
                    textError: "",
                    readOnly: !isEmptyObj(esia)
                },

                reg_region: {
                    type: "text",
                    label: "Область",
                    value: !isEmptyObj(esia) ? (esia.registerAddress && esia.registerAddress.region) || '' : '',
                    mask: onlyCyrillicChars,
                    validators: [emptyValidator],
                    hasError: !isEmptyObj(esia) ? (esia.registerAddress && esia.registerAddress.region) ? false : null : null,
                    textError: "Укажите регион регистрации",
                    required: true,
                    readOnly: !isEmptyObj(esia) && esia.registerAddress
                },
                reg_city: {
                    type: "text",
                    label: "Город",
                    value: !isEmptyObj(esia) ? (esia.registerAddress && esia.registerAddress.city) || '' : '',
                    mask: onlyCyrillicCharsNumbersDash,
                    validators: [emptyValidator],
                    hasError: !isEmptyObj(esia) ? (esia.registerAddress && esia.registerAddress.city) ? false : null : null,
                    textError: "Укажите город регистрации",
                    required: true,
                    readOnly: !isEmptyObj(esia) && esia.registerAddress
                },
                reg_street: {
                    type: "text",
                    label: "Улица",
                    value: !isEmptyObj(esia) ? (esia.registerAddress && esia.registerAddress.street) || '' : '',
                    mask: onlyCyrillicCharsNumbersDash,
                    validators: [emptyValidator],
                    hasError: !isEmptyObj(esia) ? (esia.registerAddress && esia.registerAddress.street) ? false : null : null,
                    textError: "Укажите улицу",
                    required: true,
                    readOnly: !isEmptyObj(esia) && esia.registerAddress
                },
                reg_house: {
                    type: 'text',
                    label: "Дом",
                    value: !isEmptyObj(esia) ? (esia.registerAddress && esia.registerAddress.house) || '' : '',
                    validators: [emptyValidator],
                    hasError: !isEmptyObj(esia) ? (esia.registerAddress && esia.registerAddress.house) ? false : null : null,
                    textError: "Укажите дом",
                    required: true,
                    readOnly: !isEmptyObj(esia) && esia.registerAddress
                },
                reg_block: {
                    type: 'text',
                    label: "Корпус",
                    value: !isEmptyObj(esia) ? (esia.registerAddress && esia.registerAddress.building) || '' : '',
                    mask: numberMask(1),
                    hasError: null,
                    readOnly: !isEmptyObj(esia) && esia.registerAddress
                },
                reg_flat: {
                    type: "text",
                    label: "Квартира",
                    value: !isEmptyObj(esia) ? (esia.registerAddress && esia.registerAddress.flat) || '' : '',
                    mask: numberMask(1),
                    hasError: null,
                    readOnly: !isEmptyObj(esia) && esia.registerAddress
                },

                region: {
                    type: "region",
                    label: "Область",
                    value: region ? region.name : "",
                    readOnly: false,
                    options: [],
                    trigger: false,
                    required: false,
                    hasError: null,
                    textError: "Укажите регион регистрации"
                },
                city: {
                    type: "city",
                    label: "Город",
                    value: cities.length === 1 ? cities[0].name : "",
                    readOnly: false,
                    options: [],
                    trigger: false,
                    required: false,
                    hasError: null,
                    textError: "Укажите город регистрации"
                },
                address: {
                    type: "address",
                    label: "Улица",
                    value: "",
                    options: [],
                    trigger: false,
                    hasError: null,
                    textError: "Укажите улицу"
                },
                house: {
                    type: 'house',
                    label: "Дом",
                    value: "",
                    trigger: false,
                    options: [],
                    hasError: null
                },
                block: {
                    type: 'block',
                    label: "Корпус",
                    value: "",
                    required: false,
                    trigger: false,
                    options: []
                },
                flat: {
                    type: "text",
                    label: "Квартира",
                    value: "",
                    required: false,
                    hasError: null,
                    textError: ""
                },
                checkbox_agree: {
                    type: "checkbox",
                    label: props.number_agreements_checkbox_agree_title,
                    value: false,
                    required: true,
                    hasError: null,
                    textError: ""
                }
            }
        }
    }

    onFieldChange = (name) => {
        return (e) => {
            let fields = {...this.state.fields};
            fields[name].value = fields[name].mask ? fields[name].mask(e.target.value) : e.target.value;
            this.setState({fields});
        }
    };

    onBlur = (name) => {
        return (e) => {
            let field = this.state.fields[name];
            if (field.hasOwnProperty('validators')) {
                let valid = true;
                field.validators.forEach(function (func) {
                    if (!func.call(this, field.value)) {
                        valid = false;
                    }
                });
                this.setState({
                    fields: {
                        ...this.state.fields,
                        [name]: {
                            ...this.state.fields[name],
                            hasError: !valid
                        }
                    }
                });
            }
        };
    };

    onFocus = (name) => {
        return (e) => {
            this.setState({
                fields: {
                    ...this.state.fields,
                    [name]: {
                        ...this.state.fields[name],
                        hasError: null
                    }
                }
            })
        }
    };

    renderField = (name) => {
        let field = {...this.state.fields[name]};
        let fields = this.state.fields;
        let input = null;

        switch (field.type) {
            case "select":
                input = <Select options={field.options || []}
                                value={field.value}
                                className="b-choose-plates__select"
                                onChange={(attr, value) => {
                                    let fields = {...this.state.fields};
                                    fields[name].value = value;
                                    fields[name].hasError = false;
                                    this.setState({fields});
                                }}
                                hasError={field.hasError}
                                onblur={this.onBlur(name)}
                                onfocus={this.onFocus(name)}
                                errorText={field.textError}
                                disabled={field.disabled}
                                readOnly={field.readOnly}
                />;
                break;
            case "radio":
                input = <Radio  items={field.options || []}
                                value={field.value}
                                name={name}
                                className="mnp-contacts-info__radios"
                                onChange={(attr, value) => {
                                    let fields = {...this.state.fields};
                                    fields[name].value = value;

                                    if (name === "getting_type") {
                                        ["region", "city"].forEach(
                                            (item) => {
                                                if (value === "delivery") {
                                                    fields[item].required = true;
                                                } else {
                                                    fields[item].required = false;
                                                    fields[item].hasError = null;
                                                }

                                            }
                                        )
                                    }

                                    this.setState({fields});
                                }}
                />;
                break;
            case "checkbox":
                input = <Checkbox value={field.value}
                                name={name}
                                label={field.label}
                                onChange={(attr, value) => {
                                    let fields = {...this.state.fields};
                                    fields[name].value = value;

                                    if (name === "document_agreement") {
                                        if (value) {
                                            ["document", "document_number", "who_issued", "issue_date", "reg_region", "reg_city", "reg_street", "reg_house"].forEach(
                                                (item) => {
                                                    fields[item].required = false;
                                                    fields[item].hasError = null;
                                                    fields[item].validators = [];
                                                }
                                            );
                                            ["document", "document_number", "who_issued", "issue_date", "unit_code"].forEach(
                                              (item) => {fields[item].value = ''}
                                            )
                                        } else {
                                            ["document", "document_number", "who_issued", "issue_date", "reg_region", "reg_city", "reg_street", "reg_house"].forEach(
                                                (item) => {
                                                    fields[item].required = true;
                                                    fields[item].validators = [emptyValidator];
                                                }
                                            );
                                            fields.document_number.validators.push(docNumberValidator);
                                        }
                                    }

                                    this.setState({fields});
                                }}
                />;
                break;
            case "address":
            case "city":
            case "region":
            case "house":
            case "block":

                let additionalParams = {};
                let options = [];
                let readOnly = field.readOnly, value = field.value;

                let {
                    city,
                    region
                } = this.state.fields;

                if (field.type === "region") {
                    if (this.props.forms.hasOwnProperty('region') && this.props.forms.region.length > 0) {
                        options = normalizeForSelect(this.props.forms.region);
                    } else if (this.props.regions && this.props.regions.length) {
                        options = normalizeForSelect(this.props.regions.filter((item) => item.id == this.props.regionId), 'name');
                        if (options.length === 1) {
                            readOnly = true;
                            value = options[0].value;
                        }
                    }
                }

                if (field.type === "address") {
                    if (this.props.forms.hasOwnProperty('address') && this.props.forms.address.length > 0) {
                        options = normalizeForSelect(this.props.forms.address);
                    }
                    additionalParams = {city: city.value ? city.value.replace(/(г\s)/gim, '') : null, region: region.value ? region.value.replace(/\s?(область|обл|респ|АО)\s?/gim, '') : ""};
                }

                if (field.type === "house") {
                    if (this.props.forms.hasOwnProperty('house') && this.props.forms.house.length > 0) {
                        options = normalizeForSelect(this.props.forms.house);
                    }
                    additionalParams = {city: city.value ? city.value.replace(/(г\s)/gim, '') : null, region: region.value ? region.value.replace(/\s?(область|обл|респ|АО)\s?/gim, '') : ""};
                }

                if (field.type === "block") {
                    if (this.props.forms.hasOwnProperty('block') && this.props.forms.block.length > 0) {
                        options = normalizeForSelect(this.props.forms.block);
                    }
                    additionalParams = {city: city.value ? city.value.replace(/(г\s)/gim, '') : null, region: region.value ? region.value.replace(/\s?(область|обл|респ|АО)\s?/gim, '') : ""};
                }

                if (field.type === "city") {
                    if (this.props.forms.hasOwnProperty('city') && this.props.forms.city.length > 0) {
                        options = normalizeForSelect(this.props.forms.city);
                    } else if (this.props.cities && this.props.cities.length) {
                        options = normalizeForSelect(this.props.cities.filter((item) => {
                            return item.region_id == this.props.regionId;
                        }), 'name')
                        if (options.length === 1) {
                            readOnly = true;
                            value = options[0].value;
                        }
                    }
                    additionalParams = {region: region.value ? region.value.replace(/\s?(область|обл|респ|АО)\s?/gim, '') : ""};
                }

                input = <Select options={options}
                                value={value}
                                className="b-choose-plates__select"
                                onChange={(attr, value) => {
                                    let fields = {...this.state.fields};
                                    fields[name].value = value;
                                    fields[name].hasError = false;
                                    if (field.type === "address") {
                                        this.props.clearStreet();
                                        fields.house.value = '';
                                        fields.block.value = '';
                                        fields.flat.value = '';
                                    }

                                    if (field.type === "house") {
                                        this.props.clearHouse();
                                        fields.block.value = '';
                                        fields.flat.value = '';
                                    }

                                    if (name === 'region') {
                                        this.props.clearCity();
                                        var option = this.props.forms.hasOwnProperty('region') ? this.props.forms.region.filter((item) => {
                                            return value === item.value;
                                        }) : [];
                                        if (option.length && option[0].city) {
                                            fields.city.value = option[0].city;
                                            fields.city.readOnly = true;
                                        } else {
                                            fields.city.value = '';
                                            fields.city.readOnly = false;
                                        }
                                        fields.house.value = '';
                                        fields.block.value = '';
                                        fields.address.value = '';
                                        fields.flat.value = '';
                                    }
                                    if (name === 'city') {
                                        this.props.clearAddress();
                                        fields.address.value = '';
                                        fields.house.value = '';
                                        fields.block.value = '';
                                        fields.flat.value = '';
                                    }

                                    this.setState({fields});
                                }}
                                onChangeValue={(attr, value) => {
                                    let fields = {...this.state.fields};
                                    fields[name].value = value;
                                    fields[name].hasError = false;
                                    this.setState({fields});
                                }}
                                trigger={field.trigger}
                                onFilter={(val) => {
                                        if (val.length >= 3) this.props.addressAutoComplete(field.type, val, additionalParams);

                                        if (field.type === "address" && val.length >= 3) {
                                            this.props.addressAutoComplete(field.type, val, additionalParams)
                                        }
                                        if (field.type === "house" && fields.address.value.length >= 3) {
                                            this.props.addressAutoComplete(field.type, fields.address.value + ' ' + val, additionalParams)
                                        }
                                        if (field.type === "block" && fields.house.value && fields.address.value.length >= 3) {
                                            this.props.addressAutoComplete(field.type, fields.address.value + ' ' + fields.house.value + ' ' + val, additionalParams)
                                        }
                                    }
                                }
                                allowSearch={true}
                                disabled={readOnly}
                                hasError={field.hasError}
                                onblur={this.onBlur(name)}
                                onfocus={this.onFocus(name)}
                                errorText={field.textError}
                />;
                break;
            case "date":
                input = <DatePicker onChange={(val) => {
                        let fields = {...this.state.fields};
                        fields[name].value = val ? val : "";
                        this.setState({fields});
                    }}
                    {...field}
                    hasError={field.hasError}
                    onblur={this.onBlur(name)}
                    onfocus={this.onFocus(name)}
                    disabled={field.disabled}
                    readOnly={field.readOnly}
                />;
                break;
            case "textarea":
                input = <div className="b-input-textarea__textarea-wrap">
                    <textarea className="b-input-textarea__textarea"
                              value={field.value}
                              onChange={this.onFieldChange(name)}
                    />
                </div>;
                break;
            default:
                input = <div className={`b-input-text__input-area ${field.readOnly ? "disabled" : ''}`}>
                    <InputIcon error={field.hasError} emptyValue={field.emptyValue} value={field.value} />
                    <input className={"b-input-text__input" + (field.hasError ? " has-error" : "")}
                           type="text"
                           value={field.value}
                           disabled={field.disabled}
                           onChange={this.onFieldChange(name)}
                           readOnly={field.readOnly}
                           onBlur={this.onBlur(name)}
                           onFocus={this.onFocus(name)}
                    />
                    <InputError hasError={field.hasError} errorText={field.textError}/>
                </div>;
        }

        return <div className="b-input-text__wrapper b-input-textarea_adapt_mnp-step-form">
            {field.label && field.type !== "checkbox" ? <div className="b-input-text__label b-input-text__label b-input-text__label_upper">
                <div className="b-input-text__label-text">{field.label}{field.required ? <span className={"orange"}>*</span> : ''}</div>
            </div> : null}
            {input}
        </div>
    };

    componentDidMount() {
        this.setState({location: window.location});
    }


    static contextTypes = {
        goToStep: PropTypes.func,
        step: PropTypes.number,
        fields: PropTypes.object,
        showModal: PropTypes.func
    };

    goBack = () => {
        this.context.goToStep(this.context.step - 1);
    };

    // это сабмит который отправляется при нажатии на кнопку во второй форме
    onSubmit = (e) => {
        if (e) e.preventDefault();
        let utm_start = getCookie("utm_start");
        const copy_start_params = getCookie("copy_start_params");
        let utm_finish = checkUtmParams();
        if (typeof utm_start === 'undefined' && typeof copy_start_params !== 'undefined') {
            utm_start = copy_start_params;
        }

        if (this.isValid() && !this.props.inProgress) {
            let body = {
                ...getObjectData({...this.state.fields}),
                getting_type_alias: this.state.fields.getting_type.value,
                getting_type: this.state.fields.getting_type.value === "delivery" ? this.props.getting_type_delivery_title : this.props.getting_type_pickup_title,
                form_name: "Переход_в_Мотив",
                bonus: this.props.radioValue,
                is_esia: !isEmptyObj(this.props.forms.esiaData) ? 1 : 0
            }
            if(this.props.officeData.address && this.state.fields.getting_type.value === "pickup") {
                body.city = this.props.officeData.city.name;
                body.address = this.props.officeData.address;
            }

            if (!this.props.isGuest && !!utm_start) {
                body['utm_start'] = utm_start;
                body['utm_finish'] = utm_finish;
            } else {
                console.log('no utm_start cookie')
            }

            this.props.onSubmit(body);
        }
    };

    isValid = () => {
        let fields = {...this.state.fields};

        for (let attr in fields) {
            if (fields[attr].error || (fields[attr].required && !fields[attr].value)) {
                return false;
            }
        }
        if (fields.fio.value.length < 3) {
            return false;
        }
        if (fields.document_number.value && fields.document_number.value.replace(/\D/gim, '').length !== 10) {
            return false;
        }
        if (fields.who_issued.value && fields.who_issued.value.length < 3) {
            return false;
        }

        return true;
    };

    render(){
        let {
            final_mnp_title,
            conditions,
            conditions_desc,
            getting_type_delivery_description,
            getting_type_pickup_description,
            phoneInfo,
            children,
            officeClick,
            officeData,
        } = this.props;

        return <div className="page__step-form page_mnp_step-form">
            <div className="page__step-title">{final_mnp_title}</div>
            {phoneInfo}
            <form className="b-step-form b-step-form_adapt_default" onSubmit={this.onSubmit}>
                <div className="b-step-form__wrapper">
                    {conditions ? <div className="b-step-form__block b-step-form__block_doc-download">
                        <div className="b-step-form__doc-download">
                            <div className="b-download-doc b-download-doc b-download-doc_theme_mnp-step b-download-doc b-download-doc_adapt_mnp-step">
                                <div className="b-download-doc__wrapper">
                                    <a className="b-download-doc__item b-download-doc__item_pdf" target="_blank" href={conditions}>
                                        {conditions_desc}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div> : null}
                    <div className="b-step-form__block">
                        <div className="b-step-form__row">
                            <div className="b-step-form__item b-step-form__item_size_half">
                                <div className="b-step-form__input">
                                    <div className="b-input-text b-input-text_adapt_mobile-small">
                                        {this.renderField("fio")}
                                    </div>
                                </div>
                            </div>
                            <div className="b-step-form__item b-step-form__item_size_half">
                                <div className="b-step-form__input b-step-form__input_textarea">
                                    <div className="b-input-date b-input-date_adapt_mnp-questionare">
                                        {this.renderField("birth_date")}
                                        {this.state.fields.birth_date.hasError
                                            ? <InputError hasError={true} errorText={this.state.fields.birth_date.textError} />
                                            : ""
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="b-step-form__item b-step-form__item_size_full">
                                <div className="b-step-form__input">
                                    <div className="b-input-text b-input-text_adapt_mobile-small">
                                        {this.renderField("birth_place")}
                                    </div>
                                </div>
                            </div>
                            <div className="b-step-form__item b-step-form__item_size_half">
                                <div className="b-step-form__input">
                                    <div className="b-input-text b-input-text_adapt_mobile-small">
                                        {this.renderField("callback_phone")}
                                    </div>
                                </div>
                            </div>
                            <div className="b-step-form__item b-step-form__item_size_half">
                                <div className="b-step-form__input">
                                    <div className="b-input-text b-input-text_adapt_mobile-small">
                                        {this.renderField("phone")}
                                    </div>
                                </div>
                            </div>

                            {isEmptyObj(this.props.forms.esiaData) && 
                                (<div className="b-step-form__item b-step-form__item_size_full">
                                    <div className="b-step-form__input">
                                        <div className="b-input-text b-input-text_adapt_mobile-small">
                                            {this.renderField("document_agreement")}
                                        </div>
                                    </div>
                                </div>)
                            }
                        </div>
                    </div>

                    {!this.state.fields.document_agreement.value &&
                        (<React.Fragment>
                            <div className="b-step-form__block b-step-form__block_labeled">
                                <div className="b-step-form__block-label">Документ, удостоверяющий личность</div>
                                <div className="b-step-form__row">
                                    <div className="b-step-form__item b-step-form__item_size_half">
                                        <div className="b-step-form__input">
                                            {this.renderField("document")}
                                        </div>
                                    </div>
                                    <div className="b-step-form__item b-step-form__item_size_half">
                                        <div className="b-step-form__input">
                                            <div className="b-input-text b-input-text_adapt_mobile-small">
                                                {this.renderField("document_number")}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="b-step-form__item b-step-form__item_size_full">
                                        <div className="b-step-form__input">
                                            <div className="b-input-text b-input-text_adapt_mobile-small">
                                                {this.renderField("who_issued")}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="b-step-form__item b-step-form__item_size_half">
                                        <div className="b-step-form__input b-step-form__input_textarea">
                                            <div className="b-input-date b-input-date_adapt_mnp-questionare">
                                                {this.renderField("issue_date")}
                                                {this.state.fields.issue_date.hasError
                                                    ? <InputError hasError={true} errorText={this.state.fields.issue_date.textError} />
                                                    : ""
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <div className="b-step-form__item b-step-form__item_size_half">
                                        <div className="b-step-form__input">
                                            <div className="b-input-text b-input-text_adapt_mobile-small">
                                                {this.renderField("unit_code")}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="b-step-form__block b-step-form__block_labeled">
                                <div className="b-step-form__block-label">Адрес регистрации</div>
                                <div className="b-step-form__row">
                                    <div className="b-step-form__item b-step-form__item_size_half">
                                        <div className="b-step-form__input">
                                            <div className="b-input-text b-input-text_adapt_mobile-small">
                                                {this.renderField("reg_region")}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="b-step-form__item b-step-form__item_size_half">
                                        <div className="b-step-form__input">
                                            <div className="b-input-text b-input-text_adapt_mobile-small">
                                                {this.renderField("reg_city")}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="b-step-form__item b-step-form__item_size_half">
                                        <div className="b-step-form__input">
                                            <div className="b-input-text b-input-text_adapt_mobile-small">
                                                {this.renderField("reg_street")}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="b-step-form__item b-step-form__item_size_one_sixth">
                                        <div className="b-step-form__input">
                                            <div className="b-input-text b-input-text_adapt_mobile-small">
                                                {this.renderField("reg_house")}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="b-step-form__item b-step-form__item_size_one_sixth">
                                        <div className="b-step-form__input">
                                            <div className="b-input-text b-input-text_adapt_mobile-small">
                                                {this.renderField("reg_block")}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="b-step-form__item b-step-form__item_size_one_sixth">
                                        <div className="b-step-form__input">
                                            <div className="b-input-text b-input-text_adapt_mobile-small">
                                                {this.renderField("reg_flat")}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </React.Fragment>)
                    }

                    <div className="b-step-form__block b-step-form__block_labeled">
                        <div className="b-step-form__block-label">Способ получения SIM-карты</div>
                        <div className="b-step-form__row">
                            <div className="b-step-form__item b-step-form__item_size_full">
                                <div className="b-step-form__input">
                                    {this.renderField("getting_type")}
                                </div>
                            </div>
                            <div className="b-step-form__item b-step-form__item_size_full">
                                {this.state.fields.getting_type.value === "delivery" ? getting_type_delivery_description : (
                                  <span>{officeData.address ? officeData.address : ''}</span>
                                )}
                            </div>
                        </div>
                    </div>
                    {
                      this.state.fields.getting_type.value === "pickup" &&
                      <div className="b-step-form__btns-sector_questionare mnp__map__btn_show_map">
                          <button
                            id={"mnp-client-info-button"}
                            type="button"
                            onClick={officeClick}
                            className={"b-step-form__btn-item b-step-form__btn-item_questionare u-btn u-btn_lg-responsive u-btn_default"}
                          >
                              {officeData.address ? 'Изменить адрес' : 'Выбрать офис'}
                          </button>
                      </div>
                    }

                    {this.state.fields.getting_type.value === "delivery" ? <div className="b-step-form__block">
                        <div className="b-step-form__row">
                            <div className="b-step-form__item b-step-form__item_size_half">
                                <div className="b-step-form__input">
                                    {this.renderField("region")}
                                </div>
                            </div>
                            <div className="b-step-form__item b-step-form__item_size_half">
                                <div className="b-step-form__input">
                                    {this.renderField("city")}
                                </div>
                            </div>
                            <div className="b-step-form__item b-step-form__item_size_half">
                                <div className="b-step-form__input">
                                    <div className="b-input-text b-input-text_adapt_mobile-small">
                                        {this.renderField("address")}
                                    </div>
                                </div>
                            </div>
                            <div className="b-step-form__item b-step-form__item_size_one_sixth">
                                <div className="b-step-form__input">
                                    <div className="b-input-text b-input-text_adapt_mobile-small">
                                        {this.renderField("house")}
                                    </div>
                                </div>
                            </div>
                            <div className="b-step-form__item b-step-form__item_size_one_sixth">
                                <div className="b-step-form__input">
                                    <div className="b-input-text b-input-text_adapt_mobile-small">
                                        {this.renderField("block")}
                                    </div>
                                </div>
                            </div>
                            <div className="b-step-form__item b-step-form__item_size_one_sixth">
                                <div className="b-step-form__input">
                                    <div className="b-input-text b-input-text_adapt_mobile-small">
                                        {this.renderField("flat")}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>: null}
                    
                    <div className="b-step-form__block b-step-form__block_labeled">
                        <div className="b-step-form__row">
                            <div className="b-step-form__item b-step-form__item_size_full">
                                <div className="b-step-form__input">
                                    <div className="b-input-text b-input-text_adapt_mobile-small">
                                        {this.renderField("checkbox_agree")}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className="b-step-form__btns-sector b-step-form__btns-sector_questionare">
                        <button 
                            id={"mnp-client-info-button"} 
                            type="submit" 
                            className={"b-step-form__btn-item b-step-form__btn-item_questionare u-btn u-btn_lg-responsive u-btn_default"+(!this.isValid() || this.props.inProgress ? " disabled" : "")}
                        >
                            Отправить заявку
                        </button>
                    </div>
                </div>
            </form>
            {children}
        </div>
    }
}
